<template>
  <div>
    <template v-if="token">
      <template v-if="user">
        <router-view/>
      </template>
      <template v-else>
          <error-page v-if="error" :error="error" :statusCode="statusCode"></error-page>
          <page-loader v-else></page-loader>
      </template>
    </template>
    <h2 class="text-center" v-else>Link is invalid</h2>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { WebApi } from '@/services/WebApi'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import PageLoader from '@/components/Loading/PageLoader.vue'
import ErrorPage from './ErrorPage.vue'

export default {
  name: 'ExternalView',
  data () {
    return {
      error: '',
      statusCode: 0,
      user: null
    }
  },
  computed: {
    token () {
      return this.$route.query.token
    }
  },
  methods: {
    ...mapMutations('Sites', [
      'clearSites'
    ]),
    refreshUser () {
      const self = this
      if (!self.token) {
        return
      }
      self.error = ''
      WebApi.post('Authentication/Token/Login', { token: self.token })
        .then(response => { self.user = response.data })
        .catch(error => {
          self.error = ErrorHelper.getError(error)
          self.statusCode = ErrorHelper.getStatusCode(error)
        })
    }
  },
  components: {
    'page-loader': PageLoader,
    'error-page': ErrorPage
  },
  created () {
    this.clearSites()
    this.refreshUser()
  }
}
</script>
